<template>
  <div class="container-fluid">
    <!-- Header -->
    <div class="header">
      <span class="welcome">Xin chào: <b>0979951954</b></span>
      <!-- <a href="#" class="logout">Đăng xuất</a> -->
              <a class="logout" @click="logoutTaiKhoan" >Đăng xuất</a>

    </div>

    <!-- Tabs -->
    <div class="tabs">
      <button :class="{ active: activeTab === 1 }" @click="clickDanhMuc" >
        QUẢN TRỊ DANH MỤC
      </button>
      <button :class="{ active: activeTab === 2 }" @click="clickBaiViet"  >
        QUẢN TRỊ BÀI VIẾT
      </button>
       <button :class="{ active: activeTab === 3 }" @click="clickNhanSu">
        QUẢN TRỊ NHÂN SỰ
      </button>
    </div>

    <!-- Main -->
    <div class="container-fluid">
      <div class="row justify-content-around">
        <!-- Form -->
        <div class="card-cate list-section col-12 col-md-4 p-5">
          <div class="form-group">
            <label style="text-align: start"
              >Tiêu đề danh mục <span class="sub">(Tiếng Việt)</span></label
            >
            <input type="text" v-model="form.titleVi" />
          </div>
          <div class="form-group">
            <label style="text-align: start">
              Tiêu đề danh mục <span class="sub">(Tiếng Anh)</span></label
            >
            <input type="text" v-model="form.titleEn" />
          </div>
          <div class="form-group">
            <label style="text-align: start">Thứ tự</label>
            <input type="text" v-model="form.order" />
          </div>
          <div class="form-group">
            <label style="text-align: start">Token</label>
            <input type="text" v-model="form.token" />
          </div>
          <button class="btn-primary" @click="createCategory">
            + TẠO DANH MỤC
          </button>
        </div>

        <!-- List -->
        <div class="card-cate list-section col-12 col-md-7 p-5">
          <div
            class="w-100"
            style="border-bottom: 2px solid #f0f0f0; text-align: start"
          >
            <span class="card-title">Danh sách danh mục</span>
          </div>
          <ul>
            <li v-for="item in categories" :key="item.id">
              <a href="#" class="category-link"
                >{{ item.index }} - {{ VMbase64Utf8(item.title_vi) }}</a
              >
              <span class="icon edit" title="Sửa"></span>
              <span class="icon delete" title="Xóa"></span>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { KEY_PHONE_ID } from "@/components/listService";
import { postCreateCate, postListCateBaiViet } from "@/components/VimassCrop";

export default {
  name: "QuanTriBaiViet",
  data() {
    return {
      activeTab: 1,
      form: {
        titleVi: "",
        titleEn: "",
        order: "",
        token: "",
      },
      
      user:'',
      categories: [
        
      ],
    };
  },
  mounted() {
    this.getListCategory();
    this.user = localStorage.getItem(KEY_PHONE_ID);
     if (this.user == '' || this.user == null || this.user == undefined ) {
            window.location.href = "/quantri/dangnhap";
        }
    console.log("user ", this.user);
    
  },
  methods: {
       logoutTaiKhoan() {
            localStorage.removeItem(KEY_PHONE_ID);
            window.location.href = "/quantri/dangnhap";
        },
    clickBaiViet() {

      window.location.href = "/quantri/baiviet";
    },
      clickNhanSu() {
        window.location.href = "/quantri/nhansu";
      },
    clickDanhMuc() {
      window.location.href = "/quantri/trangchu";
    },
   async createCategory() {
      let res = await postCreateCate(this.user,this.form.titleVi, this.form.titleEn, this.form.order, this.form.token, 0);
      console.log("res create cate ", res);
      
      if (res.msgCode !== 1) {
        alert("Tạo danh mục thất bại! " + res.msgContent);
        return;
      }
      alert("Tạo danh mục thành công!");
      this.getListCategory();
    },

    async getListCategory() {
      let offset = "0";
      let limit = "20";
      let langId = "0";

      let res = await postListCateBaiViet(limit, offset, langId);
      this.categories = res.result;

      console.log("res ", res.result);
    },

     VMbase64Utf8(str) {
    if (!str || typeof str !== "string") return "";
    try {
      const binary = atob(str);
      const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch (e) {
      return "";
    }
  },

    // extraString(str){
    //   return atob(str);
    // }
  },
};
</script>

<style scoped>
.card-cate {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #176a94;
  margin-bottom: 15px;

  padding-bottom: 6px;
  text-align: start;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  margin-top: 0px;
}

.logout {
  color: #ff4d4f;
  font-weight: 600;
  text-decoration: none;
}

.logout:hover {
  text-decoration: underline;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
}

.tabs button {
  background: #f5f5f5;
  color: #444;
  border: 1px solid #ddd;
  padding: 10px 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  transition: all 0.2s;
  line-height: 1;
}

.tabs button:hover {
  background: #e6f7ff;
}

.tabs button.active {
  background: #176a94;
  color: #176a94;
  border-color: #176a94;
}

/* Main */
.main-content {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

.form-section {
  flex: 1;
  max-width: 500px;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  font-weight: 600;
  display: block;
  margin-bottom: 4px;
}

.form-group .sub {
  font-weight: normal;
  font-size: 12px;
  color: #888;
}

.form-group input {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: 0.2s;
}

.form-group input:focus {
  border-color: #176a94;
  outline: none;
  box-shadow: 0 0 4px rgba(23, 106, 148, 0.2);
}

.btn-primary {
  background: #176a94;
  color: #fff;
  border: none;
  padding: 10px 25px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 10px;
  transition: 0.2s;
}

.btn-primary:hover {
  background: #145b7e;
}

/* List */
.list-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.list-section li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding: 10px 0;
  font-size: 16px;
}

.category-link {
  color: #176a94;
  font-weight: 500;
  text-decoration: none;
  flex: 1;
}

.category-link:hover {
  text-decoration: underline;
}

/* Icons */
.icon {
  display: inline-block;
  width: 22px;
  height: 22px;
  margin-left: 6px;
  cursor: pointer;
}

.icon.edit {
  background: url('data:image/svg+xml;utf8,<svg fill="green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M7 17l5-5-2-2-5 5v2h2zm9.71-9.71a1.003 1.003 0 0 0-1.42 0l-1.34 1.34 2.12 2.12 1.34-1.34a1.003 1.003 0 0 0 0-1.42l-1.7-1.7z" fill="white"/></svg>')
    no-repeat center/contain;
}

.icon.delete {
  background: url('data:image/svg+xml;utf8,<svg fill="red" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M15.5 8.5l-7 7m0-7l7 7" stroke="white" stroke-width="2"/></svg>')
    no-repeat center/contain;
}
</style>
